{
  "guidance.manager.title": "Planning reasons",
  "guidance.manager.description": "Review the reasons, protection rules, and fallback boundaries that guide future replanning.",
  "guidance.manager.error": "The planning reason could not be changed.",
  "guidance.manager.protected": "Protected",
  "guidance.manager.noPurpose": "No purpose has been recorded yet.",
  "guidance.manager.updated": "Updated {{date}} · give-way order {{order}}",
  "guidance.manager.editAction": "Edit reason",
  "guidance.manager.closeEditor": "Close editor",
  "guidance.manager.deleteAction": "Delete permanently",
  "guidance.manager.deleteTitle": "Permanently delete this planning reason?",
  "guidance.manager.deleteDescription": "The explicit reason for this {{subject}} will be removed. Any inherited reason will become effective instead.",
  "guidance.manager.cancelAction": "Cancel",
  "guidance.manager.saveAction": "Save changes",
  "guidance.manager.emptyTitle": "No explicit planning reasons",
  "guidance.manager.emptyDescription": "Add a reason from a project, goal, task, routine, plan, decision, or period when its purpose needs to survive replanning.",
  "guidance.subject.span": "Period",
  "guidance.subject.project": "Project",
  "guidance.subject.plan": "Plan",
  "guidance.subject.goal": "Goal",
  "guidance.subject.task": "Task",
  "guidance.subject.routine": "Routine",
  "guidance.subject.decision": "Decision",
  "guidance.flexibility.fixed": "Fixed",
  "guidance.flexibility.anchored": "Anchored",
  "guidance.flexibility.shiftable": "Shiftable",
  "guidance.flexibility.droppable": "Droppable",
  "guidance.field.purpose": "Why this exists",
  "guidance.field.durationReason": "Why this duration",
  "guidance.field.timingReason": "Why now",
  "guidance.field.costOfSkipping": "Cost of skipping",
  "guidance.field.expectedGain": "Expected gain",
  "guidance.field.successSignal": "Success signal",
  "guidance.field.abandonSignal": "Abandon signal",
  "guidance.field.minimumViable": "Minimum viable version",
  "guidance.field.flexibility": "Flexibility",
  "guidance.field.sacrificeOrder": "Give-way order",
  "guidance.field.protected": "Protect during replanning",
  "guidance.field.protectedHint": "Moving this item requires an explicit protection override."
}
